module.exports = __webpack_public_path__ + "img/irys-big-1.93ed9522.jpg";